/**
 * Coral hub (coral-gables / coral-ceramic / coral-resin):
 * Step 1 venue grid from Shopify type collection (city products).
 * Page shell + skeleton paint from Liquid (sync). First collection page only.
 * Scroll fetches the next page. No events/calendar until a venue is opened.
 */
(function (global) {
  'use strict';

  if (global.WorkshopBookingCoralHub) return;

  var CORAL_SUFFIXES = {
    'coral-gables': 'mosaic-workshops',
    'hub-mosaic': 'mosaic-workshops',
    'coral-ceramic': 'ceramic-workshops',
    'hub-ceramic': 'ceramic-workshops',
    'coral-resin': 'resin-workshops',
  };

  var INITIAL_TARGET = 20;
  var PAGE_SIZE = 12;

  /** Optional city-name pins (USA leftover — keep empty for UK). */
  var STORE_CITIES = [];
  /** UK permanent shops. Match product handle, not city, so Leeds popup stays popup. */
  var STORE_HANDLES = {
    'mosaic-lamp-workshop-leeds': 'Leeds Shop',
    'ceramic-painting-workshop-leeds': 'Leeds Shop',
  };
  /** Force waitlist even when events-batch returns bookable slots. */
  var WAITLIST_ONLY_HANDLES = {
    'ceramic-painting-workshop-leeds': true,
  };

  /** Ceramic hub: show every venue, but all collect waitlist (no booking). */
  function isCeramicHubWaitlistAll() {
    var s = templateSuffix();
    return s === 'hub-ceramic' || s === 'coral-ceramic';
  }

  function templateSuffix() {
    var main = document.getElementById('MainContent');
    if (main) {
      var cls = String(main.className || '');
      var m = cls.match(/theme-template-suffix-([a-z0-9-]+)/i);
      if (m && m[1] && m[1] !== 'none') return m[1].toLowerCase();
    }
    var root = document.querySelector('[data-wb-coral-hub="1"]');
    if (root) {
      var s = root.getAttribute('data-wb-template-suffix');
      if (s) return String(s).toLowerCase();
    }
    return '';
  }

  /** Only the three hub product handles — never city …-in-… PDPs. */
  var HUB_HANDLES = {
    'mosaic-lamp-workshop': true,
    'ceramic-painting-workshop': true,
    'resin-art-workshop': true,
  };

  function productHandle(booking) {
    if (!booking || !booking.getAttribute) return '';
    return String(booking.getAttribute('data-product-handle') || '')
      .trim()
      .toLowerCase();
  }

  function isCoralHub(booking) {
    var handle = productHandle(booking);
    if (!handle || !HUB_HANDLES[handle]) return false;
    if (booking.getAttribute && booking.getAttribute('data-wb-coral-hub') === '1') return true;
    return Object.prototype.hasOwnProperty.call(CORAL_SUFFIXES, templateSuffix());
  }

  function typeCollectionHandle(booking) {
    if (booking && booking.getAttribute) {
      var h = booking.getAttribute('data-wb-type-collection');
      if (h) return String(h).trim();
    }
    return CORAL_SUFFIXES[templateSuffix()] || '';
  }

  function shopDomain() {
    if (global.Shopify && global.Shopify.shop) return String(global.Shopify.shop);
    return '';
  }

  function apiBase() {
    var raw =
      (typeof global.__AOGEN_API_BASE__ === 'string' && global.__AOGEN_API_BASE__.trim()) ||
      (typeof global.__WB_FORMS_API_BASE__ === 'string' && global.__WB_FORMS_API_BASE__.trim()) ||
      '';
    return String(raw || 'https://adapter.aogen.com.au').replace(/\/+$/, '');
  }

  function rootPath() {
    return (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/';
  }

  function coralHubJsonUrl(handle, page) {
    var base = rootPath().replace(/\/?$/, '/');
    return (
      base +
      'collections/' +
      encodeURIComponent(handle) +
      '?view=coral-hub-json&page=' +
      encodeURIComponent(String(page))
    );
  }

  function collectionProductsJsonUrl(handle, page, limit) {
    var base = rootPath().replace(/\/?$/, '/');
    return (
      base +
      'collections/' +
      encodeURIComponent(handle) +
      '/products.json?limit=' +
      encodeURIComponent(String(limit || PAGE_SIZE)) +
      '&page=' +
      encodeURIComponent(String(page))
    );
  }

  function mapProductsJsonRow(p) {
    var title = String(p.title || '');
    var venueName = title;
    var idx = title.toLowerCase().lastIndexOf(' in ');
    if (idx > 0) venueName = title.slice(idx + 4).trim();
    var img =
      (p.images && p.images[0] && (p.images[0].src || p.images[0])) ||
      null;
    return {
      id: p.id,
      product_gid: 'gid://shopify/Product/' + p.id,
      handle: p.handle,
      title: title,
      venue_gid: '',
      venue_name: venueName || title,
      lat: '',
      lng: '',
      image: img,
      facility_options: [],
    };
  }

  function fetchCollectionPage(handle, page) {
    // Prefer products.json (CDN, fast). coral-hub-json is optional enrich for lat/address.
    return fetch(collectionProductsJsonUrl(handle, page, PAGE_SIZE), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      if (!res.ok) throw new Error('coral_hub_products_json_http_' + res.status);
      return res.json().then(function (body) {
        var list = (body && body.products) || [];
        return {
          ok: true,
          handle: handle,
          page: page,
          pages: null,
          products: list.map(mapProductsJsonRow),
        };
      });
    });
  }

  /** Skip venues whose availability is still unknown. */
  function venuesForPaint(venues, includeWaitlist) {
    var out = [];
    (venues || []).forEach(function (v) {
      if (!v) return;
      if (isCoralStoreVenue(v)) {
        out.push(v);
        return;
      }
      // Names/images paint before presence returns. Waitlist sort happens once known.
      if (v._wbAvailabilityKnown !== true) {
        out.push(v);
        return;
      }
      if (coralHasBookableEvents(v)) out.push(v);
      else if (includeWaitlist) out.push(v);
    });
    return sortCoralVenues(out);
  }

  /** Ordered buffer (stores → sessions → waitlist). Paint after presence. */
  function commitReadyList(booking, venues) {
    var prevShown = Number(booking.__wbCoralVisibleCount) || 0;
    var all = stampCatalogIndex(
      mergeCeramicHubWaitlistCatalog(booking, enrichVenuesFromCatalog(booking, venues || []))
    );
    booking.__wbCoralAllVenues = all;
    assignSearchCatalog(booking, all);
    // Keep scroll fetchable after seed/error path (0 blocks loadMore).
    if (!(Number(booking.__wbCoralNextPage) > 0)) booking.__wbCoralNextPage = 1;
    booking.__wbCoralCatalogReady = true;
    booking.__wbCoralBootLoading = false;
    booking.__wbCoralVisibleCount = Math.min(
      all.length,
      Math.max(prevShown, Math.min(INITIAL_TARGET, all.length))
    );
    ensureUrlDeepLinkVenueVisible(booking);
    bindInfiniteScroll(booking);
    booking.__wbCoralLoading = false;
    stampPresenceThenResort(booking);
  }

  function bootList(booking) {
    var handle = typeCollectionHandle(booking);
    if (!handle) return Promise.reject(new Error('coral_hub_collection_missing'));
    booking.__wbCoralHub = true;
    booking.__wbCoralCollectionHandle = handle;
    booking.__wbCoralNextPage = 0;
    booking.__wbCoralPages = null;
    booking.__wbCoralLoading = false;
    booking.__wbCoralBootLoading = true;
    booking.__wbCoralExhausted = false;
    booking.__wbCoralCatalogReady = false;
    booking.__wbCoralVenues = [];
    booking.__wbCoralAllVenues = [];
    booking.__wbCoralVisibleCount = 0;

    var seed = readLiquidSeed(booking);

    // First page only. Events stay off this screen; scroll fetches the next page.
    booking.__wbCoralLoading = true;
    booking.__wbCoralNextPage = 1;
    return fetchCollectionPage(handle, 1)
      .then(function (data) {
        var rows = mapPageProducts(data);
        if (rows.length < PAGE_SIZE) booking.__wbCoralExhausted = true;
        booking.__wbCoralNextPage = 2;
        var merged = dedupeVenues((seed || []).concat(rows));
        return ensurePinnedStoreVenues(merged).then(function (withPins) {
          if (!urlVenueMissing(withPins)) {
            paintLoaded(booking, withPins);
            return withPins;
          }
          booking.__wbCoralDeepLinkResolving = true;
          return fetchLinkedProductVenue().then(function (extra) {
            booking.__wbCoralDeepLinkResolving = false;
            var base =
              booking.__wbCoralAllVenues && booking.__wbCoralAllVenues.length
                ? booking.__wbCoralAllVenues.slice()
                : withPins;
            if (extra) base = dedupeVenues(base.concat([extra]));
            return ensurePinnedStoreVenues(base).then(function (finalList) {
              paintLoaded(booking, finalList);
              return finalList;
            });
          });
        });
      })
      .catch(function () {
        booking.__wbCoralBootLoading = false;
        booking.__wbCoralCatalogReady = true;
        booking.__wbCoralLoading = false;
        clearCoralSkeleton(booking);
        if (seed && seed.length) {
          commitReadyList(booking, seed);
        } else {
          paintVisibleVenues(booking);
        }
      })
      .then(function () {
        return booking.__wbCoralVenues || [];
      });
  }

  /** Next collection page. Does not request events. */
  function loadMore(booking) {
    if (
      !booking ||
      booking.__wbCoralLoading ||
      booking.__wbCoralBootLoading ||
      booking.__wbCoralDeepLinkResolving ||
      booking.__wbCoralExhausted
    ) {
      return Promise.resolve([]);
    }
    var handle = booking.__wbCoralCollectionHandle;
    var page = Number(booking.__wbCoralNextPage) || 0;
    if (!handle || page < 1) return Promise.resolve([]);
    booking.__wbCoralLoading = true;
    return fetchCollectionPage(handle, page)
      .then(function (data) {
        var rows = mapPageProducts(data);
        if (rows.length < PAGE_SIZE) booking.__wbCoralExhausted = true;
        booking.__wbCoralNextPage = page + 1;
        paintLoaded(booking, dedupeVenues((booking.__wbCoralAllVenues || []).concat(rows)));
        return rows;
      })
      .catch(function () {
        booking.__wbCoralLoading = false;
        booking.__wbCoralExhausted = true;
        return [];
      });
  }

  function paintLoaded(booking, venues) {
    // Buffer catalog order; paint only after presence so waitlist A–Z cannot flash Bristol first.
    var all = stampCatalogIndex(
      mergeCeramicHubWaitlistCatalog(booking, enrichVenuesFromCatalog(booking, venues || []))
    );
    booking.__wbCoralAllVenues = all;
    assignSearchCatalog(booking, all);
    booking.__wbCoralVenues = all.slice();
    booking.__wbCoralVisibleCount = all.length;
    booking.__wbCoralBootLoading = false;
    booking.__wbCoralCatalogReady = booking.__wbCoralExhausted === true;
    booking.__wbCoralLoading = false;
    ensureUrlDeepLinkVenueVisible(booking);
    bindInfiniteScroll(booking);
    stampPresenceThenResort(booking);
  }

  function urlVenueMissing(venues) {
    var token = getUrlVenueToken();
    if (!token) return false;
    for (var i = 0; i < (venues || []).length; i++) {
      if (coralVenueMatchesUrlToken(venues[i], token)) return false;
    }
    return true;
  }

  function trailingDigits(value) {
    var m = String(value || '').match(/(\d+)$/);
    return m ? m[1] : '';
  }

  function sameTrailingId(a, b) {
    var da = trailingDigits(a);
    var db = trailingDigits(b);
    return !!(da && db && da === db);
  }

  function indexHandleForUrlVenue() {
    var token = getUrlVenueToken();
    var eventId = '';
    try {
      eventId = String(new URLSearchParams(global.location.search).get('event_id') || '').trim();
    } catch (e) {
      eventId = '';
    }
    if (!token && !eventId) return '';
    var scripts = document.querySelectorAll('script[id^="WorkshopVenueWorkshopIndex-"]');
    for (var s = 0; s < scripts.length; s++) {
      var rows;
      try {
        rows = JSON.parse(scripts[s].textContent || '[]');
      } catch (e2) {
        continue;
      }
      if (!Array.isArray(rows)) continue;
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        if (!row) continue;
        var handle = String(row.product_handle || '').trim();
        if (!handle) continue;
        var ref = String(row.venue_ref_id || '');
        var eid = String(row.event_id || '');
        var venueOk = !token || sameTrailingId(ref, token);
        var eventOk = !eventId || sameTrailingId(eid, eventId);
        if (venueOk && eventOk) return handle;
      }
    }
    return '';
  }

  /** One city product for a share link. No events request. */
  function fetchLinkedProductVenue() {
    var handle = indexHandleForUrlVenue();
    if (!handle) return Promise.resolve(null);
    return fetchProductVenueByHandle(handle);
  }

  function fetchProductVenueByHandle(handle) {
    var h = String(handle || '')
      .trim()
      .toLowerCase();
    if (!h) return Promise.resolve(null);
    var url = rootPath().replace(/\/?$/, '/') + 'products/' + encodeURIComponent(h) + '.js';
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (prod) {
        if (!prod || !prod.id) return null;
        return productToVenue(mapProductsJsonRow(prod));
      })
      .catch(function () {
        return null;
      });
  }

  /**
   * Leeds shop (etc.) may sit past page 1 of the type collection.
   * Fetch missing STORE_HANDLES and prepend so pin sort can place them first.
   */
  function ensurePinnedStoreVenues(venues) {
    var list = venues || [];
    var have = Object.create(null);
    list.forEach(function (v) {
      var h = coralProductHandle(v);
      if (h) have[h] = true;
    });
    var missing = Object.keys(STORE_HANDLES).filter(function (h) {
      return !have[h];
    });
    if (!missing.length) return Promise.resolve(list);
    return Promise.all(
      missing.map(function (h) {
        return fetchProductVenueByHandle(h);
      })
    ).then(function (extras) {
      var pins = [];
      extras.forEach(function (v) {
        if (v) pins.push(v);
      });
      if (!pins.length) return list;
      // Catalog index before city rows so pending order stays stable; pin rank still wins sort.
      pins.forEach(function (v, i) {
        v._wbCatalogIndex = i - pins.length;
      });
      return dedupeVenues(pins.concat(list));
    });
  }

  function coralVenueSortName(v) {
    return String((v && (v.venue_name || v.name)) || '').trim();
  }

  function coralCityBase(name) {
    var n = String(name || '')
      .trim()
      .toLowerCase();
    if (!n) return '';
    var comma = n.indexOf(',');
    if (comma >= 0) n = n.slice(0, comma).trim();
    return n;
  }

  function coralProductHandle(v) {
    return String((v && (v.product_handle || v.sell_product_handle)) || '')
      .trim()
      .toLowerCase();
  }

  function storePinRank(v) {
    if (!v) return -1;
    if (STORE_HANDLES[coralProductHandle(v)]) return 0;
    var venueHandle = String(v.venue_handle || '')
      .trim()
      .toLowerCase();
    if (venueHandle.indexOf('shop-') === 0) return 0;
    var base = coralCityBase(coralVenueSortName(v));
    var handle = coralProductHandle(v);
    for (var i = 0; i < STORE_CITIES.length; i++) {
      var city = String(STORE_CITIES[i]).toLowerCase();
      var slug = city.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      if (base === city) return i;
      if (handle && handle.indexOf('-in-' + slug) >= 0) return i;
    }
    if (v._coral_store === true || String(v.venue_type || '').toLowerCase() === 'store') return 0;
    return -1;
  }

  function isCoralStoreVenue(v) {
    return storePinRank(v) >= 0;
  }

  function coralHasBookableEvents(v) {
    if (!v) return false;
    if (v._wbWaitlistVenue === true) return false;
    // Only known sessions count — unknown stays with waitlist until presence returns.
    if (v._wbAvailabilityKnown !== true) return false;
    return v.has_events === true;
  }

  /** Earliest upcoming session key (YYYY-MM-DD) for hub session sort. */
  function coralNextSessionKey(v) {
    if (!v) return '';
    var k = String(v.next_date_key || '').trim();
    if (k) return k.length >= 10 ? k.slice(0, 10) : k;
    var events = Array.isArray(v.events) ? v.events : [];
    for (var i = 0; i < events.length; i++) {
      var ev = events[i];
      if (!ev) continue;
      var raw = String(ev.date_key || ev.starts_at || '').trim();
      if (!raw) continue;
      return raw.length >= 10 ? raw.slice(0, 10) : raw;
    }
    return '';
  }

  function stampCatalogIndex(venues) {
    var list = venues || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i]._wbCatalogIndex == null) list[i]._wbCatalogIndex = i;
    }
    return list;
  }

  /**
   * Hub order:
   * 1) pinned stores (UK: Leeds shop)
   * 2) venues with sessions — nearest event date first
   * 3) known waitlist — A→Z
   * Pending (no presence yet): keep catalog order — never A–Z (Bristol flash).
   */
  function sortCoralVenues(venues) {
    return (venues || []).slice().sort(function (a, b) {
      var aRank = storePinRank(a);
      var bRank = storePinRank(b);
      var aStore = aRank >= 0 ? 0 : 1;
      var bStore = bRank >= 0 ? 0 : 1;
      if (aStore !== bStore) return aStore - bStore;
      if (aRank >= 0 && bRank >= 0 && aRank !== bRank) return aRank - bRank;

      var aEv = coralHasBookableEvents(a) ? 0 : 1;
      var bEv = coralHasBookableEvents(b) ? 0 : 1;
      if (aEv !== bEv) return aEv - bEv;

      if (aEv === 0) {
        var aKey = coralNextSessionKey(a);
        var bKey = coralNextSessionKey(b);
        if (aKey && bKey && aKey !== bKey) return aKey < bKey ? -1 : 1;
        if (aKey && !bKey) return -1;
        if (!aKey && bKey) return 1;
      }

      var aKnown = !!(a && a._wbAvailabilityKnown === true);
      var bKnown = !!(b && b._wbAvailabilityKnown === true);
      if (aKnown && bKnown) {
        return coralVenueSortName(a).localeCompare(coralVenueSortName(b), undefined, {
          sensitivity: 'base',
        });
      }
      return (Number(a && a._wbCatalogIndex) || 0) - (Number(b && b._wbCatalogIndex) || 0);
    });
  }

  /** Presence stamp → sort (pin → nearest session → waitlist A–Z) → paint. */
  function stampPresenceThenResort(booking) {
    if (!booking) return Promise.resolve([]);
    var all = booking.__wbCoralAllVenues || [];
    if (!all.length) return Promise.resolve([]);
    if (booking.__wbCoralPresenceStampInFlight) {
      booking.__wbCoralPresenceStampPending = true;
      return booking.__wbCoralPresenceStampInFlight;
    }
    var unknown = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i] && all[i]._wbAvailabilityKnown !== true) unknown.push(all[i]);
    }
    function applySorted() {
      var sorted = venuesForPaint(booking.__wbCoralAllVenues || [], true);
      booking.__wbCoralAllVenues = sorted;
      booking.__wbCoralVenues = sorted.slice();
      if (booking.__wbCoralSearchCatalog && booking.__wbCoralSearchCatalog.length) {
        booking.__wbCoralSearchCatalog = sortCoralVenues(booking.__wbCoralSearchCatalog);
      } else {
        assignSearchCatalog(booking, sorted);
      }
      // Force DOM refresh after reorder (fingerprint can match on same set, wrong order).
      booking.__wbCoralPaintedFp = '';
      clearCoralSkeleton(booking);
      paintVisibleVenues(booking);
      return sorted;
    }
    if (!unknown.length) {
      applySorted();
      return Promise.resolve(booking.__wbCoralAllVenues || []);
    }
    booking.__wbCoralPresenceStampInFlight = enrichVenuesAvailability(unknown, {
      horizonDays: 180,
    })
      .then(function () {
        booking.__wbCoralPresenceStampInFlight = null;
        applySorted();
        if (booking.__wbCoralPresenceStampPending) {
          booking.__wbCoralPresenceStampPending = false;
          return stampPresenceThenResort(booking);
        }
        return booking.__wbCoralAllVenues || [];
      })
      .catch(function () {
        booking.__wbCoralPresenceStampInFlight = null;
        booking.__wbCoralPresenceStampPending = false;
        applySorted();
        return booking.__wbCoralAllVenues || [];
      });
    return booking.__wbCoralPresenceStampInFlight;
  }

  function markStoreFlag(v) {
    if (!v) return v;
    var shopLabel = STORE_HANDLES[coralProductHandle(v)];
    if (shopLabel) {
      v.venue_name = shopLabel;
      v.name = shopLabel;
      if (!String(v.city_name || '').trim()) {
        v.city_name = shopLabel.replace(/\s+shop$/i, '').trim();
      }
    }
    if (isCoralStoreVenue(v)) {
      v._coral_store = true;
      v.venue_type = 'store';
    } else {
      v._coral_store = false;
      if (!v.venue_type) v.venue_type = 'popup';
    }
    return v;
  }

  function productToVenue(p) {
    var venueGid = String(p.venue_gid || '').trim();
    var name = String(p.venue_name || '').trim() || String(p.title || '').trim() || 'Venue';
    var address = String(p.address || p.venue_address || p.map_location_address || '').trim();
    var lat = Number(p.lat);
    var lng = Number(p.lng);
    var facilities = p.facility_options;
    if (typeof facilities === 'string') {
      try {
        facilities = JSON.parse(facilities);
      } catch (e) {
        facilities = [];
      }
    }
    if (!Array.isArray(facilities)) facilities = [];
    // venue_gid optional when products.json fallback — calendar uses product_gid only.
    if (!venueGid) venueGid = 'product:' + String(p.product_gid || p.id || name);
    return markStoreFlag({
      venue_ref_id: venueGid,
      venue_name: name,
      name: name,
      address: address,
      venue_address: address,
      has_events: false,
      events: [],
      events_count: 0,
      lat: Number.isFinite(lat) ? lat : null,
      lng: Number.isFinite(lng) ? lng : null,
      image: p.image || null,
      image_url: p.image || null,
      facility_options: facilities,
      sell_product_gid: String(p.product_gid || '').trim(),
      sell_product_handle: String(p.handle || '').trim(),
      product_gid: String(p.product_gid || '').trim(),
      product_handle: String(p.handle || '').trim(),
      _coral_hub: true,
      _coral_venue_optional: String(p.venue_gid || '').trim() === '',
    });
  }

  function venuesToList(venues) {
    return {
      groups: [
        {
          key: 'coral-hub',
          label: 'Venues',
          venues: venues,
        },
      ],
    };
  }

  function readWaitlistCatalog(booking) {
    if (!booking || !booking.querySelector) return [];
    var el = booking.querySelector('script[type="application/json"][data-wb-venues-waitlist-catalog]');
    if (!el || !el.textContent) return [];
    try {
      var raw = JSON.parse(String(el.textContent || '').trim() || '[]');
      return Array.isArray(raw) ? raw : [];
    } catch (e) {
      return [];
    }
  }

  /**
   * Ceramic hub: ceramic-workshops collection is empty — only Leeds seed appears.
   * Fill the grid from venue metaobject catalog; every card is waitlist-only.
   */
  function mergeCeramicHubWaitlistCatalog(booking, venues) {
    if (!isCeramicHubWaitlistAll()) return venues || [];
    var rows = readWaitlistCatalog(booking);
    if (!rows.length) return venues || [];
    var list = (venues || []).slice();
    var byRef = Object.create(null);
    var byName = Object.create(null);
    list.forEach(function (v) {
      if (!v) return;
      var ref = String(v.venue_ref_id || v.venue_gid || '').trim();
      if (ref) {
        byRef[ref] = true;
        var m = ref.match(/(\d+)$/);
        if (m) byRef[m[1]] = true;
      }
      var n = normName(v.venue_name || v.name || v.city_name || '');
      if (n) byName[n] = true;
    });
    var hubHandle = productHandle(booking) || 'ceramic-painting-workshop';
    var hubGid = String(
      (booking && booking.getAttribute && booking.getAttribute('data-product-gid')) || ''
    ).trim();
    var hubImage = String(
      (booking && booking.getAttribute && booking.getAttribute('data-product-image-url')) || ''
    ).trim();
    rows.forEach(function (row) {
      if (!row) return;
      var ref = String(row.venue_ref_id || '').trim();
      if (!ref) return;
      var name = String(row.venue_name || row.name || row.city || '').trim() || 'Venue';
      var nameKey = normName(name);
      var digit = (ref.match(/(\d+)$/) || [])[1] || '';
      if (byRef[ref] || (digit && byRef[digit]) || (nameKey && byName[nameKey])) return;
      var lat = Number(row.lat != null ? row.lat : row.latitude);
      var lng = Number(row.lng != null ? row.lng : row.longitude);
      var addr = String(row.venue_address || row.address || '').trim();
      var img = String(row.venue_image || row.image || hubImage || '').trim() || null;
      var stub = {
        venue_ref_id: ref,
        venue_name: name,
        name: name,
        city_name: name,
        city: String(row.city || name).trim(),
        address: addr,
        venue_address: addr,
        lat: Number.isFinite(lat) ? lat : null,
        lng: Number.isFinite(lng) ? lng : null,
        image: img,
        image_url: img,
        venue_image: img,
        has_events: false,
        events: [],
        events_count: 0,
        next_date_key: '',
        _wbWaitlistVenue: true,
        _wbAvailabilityKnown: true,
        sell_product_gid: hubGid,
        sell_product_handle: hubHandle,
        product_gid: hubGid,
        product_handle: hubHandle,
        _coral_hub: true,
        _coral_catalog_waitlist: true,
        _coral_venue_optional: false,
      };
      if (row.region_code) stub.region_code = String(row.region_code).trim();
      if (row.state_code || row.region_code) {
        stub.state_code = String(row.state_code || row.region_code).trim();
      }
      list.push(markStoreFlag(stub));
      byRef[ref] = true;
      if (digit) byRef[digit] = true;
      if (nameKey) byName[nameKey] = true;
    });
    return list;
  }

  function normName(s) {
    return String(s || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /** Fill address/lat/lng/venue_ref_id from Liquid venue catalog (metaobjects). */
  function enrichVenuesFromCatalog(booking, venues) {
    var rows = readWaitlistCatalog(booking);
    if (!rows.length || !venues || !venues.length) return venues || [];
    var byRef = Object.create(null);
    var byName = Object.create(null);
    rows.forEach(function (row) {
      if (!row) return;
      var ref = String(row.venue_ref_id || '').trim();
      if (ref) {
        byRef[ref] = row;
        var m = ref.match(/(\d+)$/);
        if (m) byRef[m[1]] = row;
      }
      var n = normName(row.venue_name || row.name || row.city);
      if (n) byName[n] = row;
    });
    venues.forEach(function (v) {
      if (!v) return;
      var ref = String(v.venue_ref_id || v.venue_gid || '').trim();
      var fakeRef = !ref || ref.indexOf('product:') === 0;
      var row =
        (!fakeRef && ref && (byRef[ref] || byRef[(ref.match(/(\d+)$/) || [])[1] || ''])) || null;
      if (!row) row = byName[normName(v.venue_name || v.name)] || null;
      if (!row) return;
      var catRef = String(row.venue_ref_id || '').trim();
      // products.json has no venue metafield — stamp real metaobject GID for ?venue= deep links.
      if (catRef && fakeRef) {
        v.venue_ref_id = catRef;
        v._coral_venue_optional = false;
      }
      var addr = String(row.venue_address || row.address || '').trim();
      if (addr) {
        if (!v.address) v.address = addr;
        if (!v.venue_address) v.venue_address = addr;
      }
      var lat = Number(row.lat != null ? row.lat : row.latitude);
      var lng = Number(row.lng != null ? row.lng : row.longitude);
      if (v.lat == null && Number.isFinite(lat)) v.lat = lat;
      if (v.lng == null && Number.isFinite(lng)) v.lng = lng;
      if (!v.region_code && row.region_code) v.region_code = String(row.region_code).trim();
      if (!v.state_code && (row.state_code || row.region_code)) {
        v.state_code = String(row.state_code || row.region_code).trim();
      }
    });
    return venues;
  }

  function getUrlVenueToken() {
    try {
      return (new URLSearchParams(global.location.search).get('venue') || '').trim();
    } catch (e) {
      return '';
    }
  }

  function coralVenueMatchesUrlToken(venue, token) {
    if (!venue || !token) return false;
    var H = global.WorkshopBookingWizardHelpers;
    if (H && typeof H.venueMatchesUrlToken === 'function') {
      return H.venueMatchesUrlToken(venue, token);
    }
    var t = String(token).trim().toLowerCase();
    var ref = String(venue.venue_ref_id || '').trim();
    var m = ref.match(/(\d+)$/);
    if (m && String(m[1]) === t) return true;
    if (ref.toLowerCase() === t) return true;
    var name = String(venue.venue_name || venue.name || '')
      .trim()
      .toLowerCase();
    return name === t;
  }

  /** Deep-link ?venue= must be in the painted slice or wizard never selects / never fetches sell variants. */
  function ensureUrlDeepLinkVenueVisible(booking) {
    var token = getUrlVenueToken();
    if (!token || !booking) return false;
    var all = booking.__wbCoralAllVenues || [];
    var idx = -1;
    for (var i = 0; i < all.length; i++) {
      if (coralVenueMatchesUrlToken(all[i], token)) {
        idx = i;
        break;
      }
    }
    if (idx < 0) return false;
    var need = Math.max(Number(booking.__wbCoralVisibleCount) || 0, idx + 1, INITIAL_TARGET);
    booking.__wbCoralVisibleCount = Math.min(all.length, need);
    return true;
  }

  function applyVenueList(booking, venues) {
    venues = enrichVenuesFromCatalog(booking, sortCoralVenues(venues || []));
    var list = venuesToList(venues);
    booking.__wbCoralVenues = venues.slice();
    booking.__wbWizardInitialVenueList = list;
    if (typeof booking.__wbApplyVenueList === 'function') {
      booking.__wbApplyVenueList(list);
      return;
    }
    // Fallback: dispatch for location.js to pick up if wired.
    try {
      booking.dispatchEvent(
        new CustomEvent('wb:coral-hub-venues', { bubbles: true, detail: { venueList: list } })
      );
    } catch (e) {
      /* ignore */
    }
  }

  function dedupeVenues(venues) {
    var seen = Object.create(null);
    var out = [];
    (venues || []).forEach(function (v) {
      if (!v || !v.sell_product_gid) return;
      if (seen[v.sell_product_gid]) return;
      seen[v.sell_product_gid] = true;
      out.push(v);
    });
    return out;
  }

  function paintVisibleVenues(booking) {
    var all = booking.__wbCoralAllVenues || [];
    var shown = Number(booking.__wbCoralVisibleCount) || 0;
    if (shown < 1) shown = Math.min(INITIAL_TARGET, all.length);
    booking.__wbCoralVisibleCount = shown;
    applyVenueList(booking, all.slice(0, shown));
    reconnectScrollObserver(booking);
    return all.slice(0, shown);
  }

  function collectionCountJsonUrl(handle) {
    var base = rootPath().replace(/\/?$/, '/');
    return base + 'collections/' + encodeURIComponent(handle) + '.json';
  }

  function fetchCollectionPageCount(handle) {
    return fetch(collectionCountJsonUrl(handle), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) return 8;
        return res.json().then(function (body) {
          var n = Number((body && body.collection && body.collection.products_count) || 0);
          if (!Number.isFinite(n) || n <= 0) return 8;
          return Math.max(1, Math.ceil(n / PAGE_SIZE));
        });
      })
      .catch(function () {
        return 8;
      });
  }

  function mapPageProducts(data) {
    var out = [];
    ((data && data.products) || []).forEach(function (p) {
      var v = productToVenue(p);
      if (v && v.sell_product_gid) out.push(v);
    });
    return out;
  }

  function fetchCollectionPages(handle, pageNums) {
    return Promise.all(
      (pageNums || []).map(function (p) {
        return fetchCollectionPage(handle, p).catch(function () {
          return { products: [] };
        });
      })
    ).then(function (pages) {
      var all = [];
      pages.forEach(function (data) {
        all = all.concat(mapPageProducts(data));
      });
      return dedupeVenues(all);
    });
  }

  function fetchAllCollectionVenues(handle) {
    // Shopify products.json max 250 — one request covers ~95 city products.
    var LIMIT = 250;

    function fetchPage(page) {
      return fetch(collectionProductsJsonUrl(handle, page, LIMIT), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (res) {
          if (!res.ok) return { products: [] };
          return res.json().then(function (body) {
            return { products: ((body && body.products) || []).map(mapProductsJsonRow) };
          });
        })
        .catch(function () {
          return { products: [] };
        });
    }

    return fetchPage(1).then(function (first) {
      var all = mapPageProducts(first);
      if (all.length < LIMIT) return dedupeVenues(all);

      function next(page, acc) {
        return fetchPage(page).then(function (data) {
          var rows = mapPageProducts(data);
          acc = acc.concat(rows);
          if (rows.length < LIMIT) return dedupeVenues(acc);
          return next(page + 1, acc);
        });
      }
      return next(2, all);
    });
  }

  function readLiquidSeed(booking) {
    if (!booking || !booking.querySelector) return [];
    var el = booking.querySelector('script[type="application/json"][data-wb-coral-seed]');
    if (!el || !el.textContent) return [];
    try {
      var raw = JSON.parse(String(el.textContent || '').trim() || '[]');
      if (!Array.isArray(raw)) return [];
      return raw
        .map(function (p) {
          if (!p || !p.id) return null;
          return productToVenue({
            id: p.id,
            product_gid: 'gid://shopify/Product/' + p.id,
            handle: p.handle,
            title: p.title,
            venue_name: p.venue_name || '',
            venue_gid: '',
            image: p.image || null,
            facility_options: [],
          });
        })
        .filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function clearCoralSkeleton(booking) {
    if (!booking) return;
    var sk = booking.querySelector('[data-wb-coral-skeleton]');
    if (sk && sk.parentNode) sk.parentNode.removeChild(sk);
  }

  function findScrollRoot(booking) {
    // Wizard Step 1 scrolls inside [data-events-panel="1"] (absolute + overflow-y:auto).
    var preferred = [
      booking.querySelector('[data-events-panel="1"]'),
      booking.querySelector('.workshop-booking-scroll'),
      booking.querySelector('[data-events-list-slot]'),
    ];
    for (var i = 0; i < preferred.length; i++) {
      var el = preferred[i];
      if (!el) continue;
      try {
        var style = global.getComputedStyle(el);
        var oy = style && style.overflowY;
        if (oy === 'auto' || oy === 'scroll' || oy === 'overlay') return el;
      } catch (e) {
        /* ignore */
      }
    }
    // Walk up from the venue list until we hit an overflow scroller.
    var start =
      booking.querySelector('[data-workshop-events]') ||
      booking.querySelector('.wbw-venue-flat-list');
    var node = start;
    while (node && node !== booking.parentElement) {
      if (node.nodeType === 1) {
        try {
          var st = global.getComputedStyle(node);
          var oy2 = st && st.overflowY;
          if (
            (oy2 === 'auto' || oy2 === 'scroll' || oy2 === 'overlay') &&
            node.scrollHeight > node.clientHeight + 4
          ) {
            return node;
          }
        } catch (e2) {
          /* ignore */
        }
      }
      node = node.parentElement;
    }
    return preferred[0] || null;
  }

  function ensureScrollSentinel(booking) {
    var list =
      booking.querySelector('.wbw-venue-flat-list') ||
      booking.querySelector('[data-workshop-events]') ||
      booking.querySelector('.workshop-events-list');
    if (!list) return null;
    var sentinel = booking.__wbCoralSentinel;
    if (!sentinel || !sentinel.isConnected) {
      sentinel = document.createElement('div');
      sentinel.setAttribute('data-wb-coral-sentinel', '1');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText =
        'width:100%;height:64px;pointer-events:none;flex:0 0 auto;grid-column:1/-1;';
      booking.__wbCoralSentinel = sentinel;
    }
    if (sentinel.parentNode !== list) list.appendChild(sentinel);
    return sentinel;
  }

  function distanceToBottom(root) {
    if (root && root.nodeType === 1) {
      return root.scrollHeight - (root.scrollTop + root.clientHeight);
    }
    var doc = global.document.documentElement;
    var body = global.document.body;
    var scrollY = global.pageYOffset || (doc && doc.scrollTop) || 0;
    var vh = global.innerHeight || (doc && doc.clientHeight) || 0;
    var sh = Math.max(
      (doc && doc.scrollHeight) || 0,
      (body && body.scrollHeight) || 0
    );
    return sh - (scrollY + vh);
  }

  function shouldPrefetchMore(booking, root) {
    if (!booking || booking.__wbCoralExhausted || booking.__wbCoralBootLoading || booking.__wbCoralLoading) {
      return false;
    }
    root = root || findScrollRoot(booking);
    if (!root || root.nodeType !== 1) return false;
    var vh = root.clientHeight || 600;
    return distanceToBottom(root) <= Math.max(320, vh * 0.65);
  }

  /** List re-render destroys sentinel; must re-observe + rebind scroll after every paint. */
  function reconnectScrollObserver(booking) {
    if (!booking) return;
    var sentinel = ensureScrollSentinel(booking);
    var root = findScrollRoot(booking) || booking.querySelector('[data-events-panel="1"]');
    booking.__wbCoralScrollRoot = root;

    if (booking.__wbCoralScrollOnScroll) {
      try {
        if (
          booking.__wbCoralScrollRootBound &&
          booking.__wbCoralScrollRootBound !== root
        ) {
          booking.__wbCoralScrollRootBound.removeEventListener(
            'scroll',
            booking.__wbCoralScrollOnScroll
          );
        }
      } catch (e) {
        /* ignore */
      }
      if (root) {
        try {
          root.removeEventListener('scroll', booking.__wbCoralScrollOnScroll);
        } catch (e2) {
          /* ignore */
        }
        root.addEventListener('scroll', booking.__wbCoralScrollOnScroll, { passive: true });
        booking.__wbCoralScrollRootBound = root;
      }
    }

    if (!sentinel) return;
    if (typeof IntersectionObserver === 'function') {
      try {
        if (booking.__wbCoralIO) booking.__wbCoralIO.disconnect();
      } catch (e3) {
        /* ignore */
      }
      booking.__wbCoralIO = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i] && entries[i].isIntersecting) {
              if (typeof booking.__wbCoralScrollMaybeLoad === 'function') {
                booking.__wbCoralScrollMaybeLoad();
              }
              break;
            }
          }
        },
        {
          root: root && root.nodeType === 1 ? root : null,
          rootMargin: '80px 0px',
          threshold: 0,
        }
      );
      booking.__wbCoralIO.observe(sentinel);
    }
  }

  function bindInfiniteScroll(booking) {
    function maybeLoad() {
      if (booking.__wbCoralLoading || booking.__wbCoralBootLoading || booking.__wbCoralExhausted) {
        return;
      }
      var root =
        findScrollRoot(booking) ||
        booking.querySelector('[data-events-panel="1"]') ||
        booking.__wbCoralScrollRoot;
      booking.__wbCoralScrollRoot = root;
      if (!shouldPrefetchMore(booking, root)) return;
      loadMore(booking).catch(function () {});
    }
    booking.__wbCoralScrollMaybeLoad = maybeLoad;
    booking.__wbCoralScrollOnScroll = function () {
      maybeLoad();
    };

    if (!booking.__wbCoralScrollBound) {
      booking.__wbCoralScrollBound = true;
    }
    reconnectScrollObserver(booking);
  }

  function monthBounds(year, month1to12) {
    var Cal = global.WorkshopBookingCalendarWindow;
    if (Cal && typeof Cal.monthDateBounds === 'function') return Cal.monthDateBounds(year, month1to12);
    var pad = function (n) {
      return (n < 10 ? '0' : '') + n;
    };
    var last = new Date(year, month1to12, 0).getDate();
    return {
      from: year + '-' + pad(month1to12) + '-01',
      to: year + '-' + pad(month1to12) + '-' + pad(last),
    };
  }

  function windowBounds(year, month1to12, lookahead) {
    var Cal = global.WorkshopBookingCalendarWindow;
    if (Cal && typeof Cal.windowDateBounds === 'function') {
      return Cal.windowDateBounds(year, month1to12, lookahead);
    }
    var start = monthBounds(year, month1to12);
    var endYmMonth = month1to12 + Number(lookahead || 0);
    var y = year;
    while (endYmMonth > 12) {
      endYmMonth -= 12;
      y += 1;
    }
    var end = monthBounds(y, endYmMonth);
    return { from: start.from, to: end.to };
  }

  function fetchEventsBatch(opts) {
    var url = apiBase() + '/api/public/workshop-venue/events-batch';
    var gids = Array.isArray(opts.productGids)
      ? opts.productGids
      : opts.productGid
        ? [opts.productGid]
        : [];
    gids = gids
      .map(function (g) {
        return String(g || '').trim();
      })
      .filter(Boolean);
    var body = {
      shop_domain: shopDomain(),
      product_gids: gids,
      date_from: opts.dateFrom,
      date_to: opts.dateTo,
    };
    if (opts.horizonDays != null && Number(opts.horizonDays) > 0) {
      body.horizon_days = Number(opts.horizonDays);
      delete body.date_from;
      delete body.date_to;
    }
    if (opts.maxSlotsPerProduct != null && Number(opts.maxSlotsPerProduct) > 0) {
      body.max_slots_per_product = Math.floor(Number(opts.maxSlotsPerProduct));
    }
    if (opts.presenceOnly === true) {
      body.presence_only = true;
    }
    var vref = String(opts.venueRefId || '').trim();
    if (vref && vref.indexOf('product:') !== 0) {
      body.venue_ref_ids = [vref];
    }
    return fetch(url, {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      signal: opts.signal,
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok || !json || json.ok === false) {
          var err = new Error((json && json.description) || 'events_batch_failed');
          err.status = res.status;
          err.body = json;
          throw err;
        }
        return json;
      });
    });
  }

  function slotsToEvents(batchBody, venueRefId) {
    var products = (batchBody && batchBody.products) || [];
    var out = [];
    // products.json has no venue metafield → venue_ref_id is "product:<gid>".
    // Do not filter slots against that fake id (API returns real metaobject GIDs).
    var fakeVenue = !venueRefId || String(venueRefId).indexOf('product:') === 0;
    products.forEach(function (row) {
      (row.slots || []).forEach(function (slot) {
        if (!slot) return;
        if (
          !fakeVenue &&
          venueRefId &&
          slot.venue_ref_id &&
          String(slot.venue_ref_id) !== String(venueRefId)
        ) {
          return;
        }
        out.push({
          id: slot.event_id,
          gid: slot.event_id,
          event_id: slot.event_id,
          handle: String(slot.handle || '').trim(),
          date_key: slot.date_key,
          starts_at: slot.starts_at,
          time_label: slot.time_label,
          // Keep selected coral venue key so calendar attaches to the card.
          venue_ref_id: fakeVenue ? venueRefId : slot.venue_ref_id || venueRefId,
          status: slot.status || 'active',
          display_status: slot.display_status || 'bookable',
          capacity_remaining: slot.capacity_remaining,
          canonical_event_id: slot.canonical_event_id,
          capacity_group_id: slot.capacity_group_id,
          product_gid: row.product_gid,
          product_handle: row.product_handle,
          _raw: {
            handle: String(slot.handle || '').trim(),
            event_id: slot.event_id,
            capacity_group_id: slot.capacity_group_id,
            canonical_event_id: slot.canonical_event_id,
          },
        });
      });
    });
    return out;
  }

  /** Stamp has_events / next_date. Chunks run in parallel; caller paints once after. */
  function enrichVenuesAvailability(venues, opts) {
    var list = venues || [];
    if (!list.length) return Promise.resolve(list);
    var CHUNK = 24;
    var gids = [];
    var seen = Object.create(null);
    var byGid = Object.create(null);
    var ordered = list.slice().sort(function (a, b) {
      var aS = isCoralStoreVenue(a) ? 0 : 1;
      var bS = isCoralStoreVenue(b) ? 0 : 1;
      return aS - bS;
    });
    ordered.forEach(function (v) {
      var g = String((v && (v.sell_product_gid || v.product_gid)) || '').trim();
      if (!g) return;
      if (!byGid[g]) byGid[g] = [];
      byGid[g].push(v);
      if (seen[g]) return;
      seen[g] = true;
      gids.push(g);
    });
    if (!gids.length) return Promise.resolve(list);
    var chunks = [];
    for (var i = 0; i < gids.length; i += CHUNK) chunks.push(gids.slice(i, i + CHUNK));
    var today = new Date();
    var todayKey =
      today.getFullYear() +
      '-' +
      (today.getMonth() + 1 < 10 ? '0' : '') +
      (today.getMonth() + 1) +
      '-' +
      (today.getDate() < 10 ? '0' : '') +
      today.getDate();

    function firstFutureSlot(slots) {
      var rows = (slots || []).slice().sort(function (a, b) {
        return String((a && (a.starts_at || a.date_key)) || '').localeCompare(
          String((b && (b.starts_at || b.date_key)) || '')
        );
      });
      for (var si = 0; si < rows.length; si++) {
        var slot = rows[si];
        if (!slot) continue;
        var dk = String(slot.date_key || '').trim();
        if (!dk || dk < todayKey) continue;
        var ds = String(slot.display_status || slot.status || '').toLowerCase();
        if (ds === 'sold_out' || ds === 'hidden' || ds === 'cancelled') continue;
        // presence_only responses omit capacity_remaining — treat null as ok.
        if (slot.capacity_remaining != null && Number(slot.capacity_remaining) <= 0) continue;
        return slot;
      }
      return null;
    }

    function stampGids(chunkGids, slotsByGid) {
      chunkGids.forEach(function (g) {
        var first = firstFutureSlot((g && slotsByGid[g]) || []);
        (byGid[g] || []).forEach(function (v) {
          if (!v) return;
          if (WAITLIST_ONLY_HANDLES[coralProductHandle(v)] || isCeramicHubWaitlistAll()) {
            v._wbAvailabilityKnown = true;
            v.has_events = false;
            v.events_count = 0;
            v._wbWaitlistVenue = true;
            v.events = [];
            v.next_date_key = '';
            return;
          }
          if (v._wbPopupCalInFlight && v._wbPopupAllLoaded !== true) return;
          if (v._wbPopupAllLoaded === true && Array.isArray(v.events) && v.events.length > 0) {
            v._wbAvailabilityKnown = true;
            v.has_events = true;
            v._wbWaitlistVenue = false;
            return;
          }
          v._wbAvailabilityKnown = true;
          if (!first) {
            v.has_events = false;
            v.events_count = 0;
            v._wbWaitlistVenue = true;
            v.events = [];
            v.next_date_key = '';
            return;
          }
          v.has_events = true;
          v.events_count = 1;
          v._wbWaitlistVenue = false;
          v.next_date_key = String(first.date_key || '').trim();
          v.events = slotsToEvents(
            { products: [{ product_gid: g, product_handle: v.product_handle || null, slots: [first] }] },
            v.venue_ref_id
          );
        });
      });
    }

    return Promise.all(
      chunks.map(function (chunk) {
        return fetchEventsBatch({
          productGids: chunk,
          horizonDays: (opts && Number(opts.horizonDays) > 0 ? Number(opts.horizonDays) : 60),
          maxSlotsPerProduct: 1,
          // Hub grid: catalog presence only — skip live capacity (main latency).
          presenceOnly: true,
        })
          .catch(function () {
            return null;
          })
          .then(function (json) {
            var slotsByGid = Object.create(null);
            if (json && Array.isArray(json.products)) {
              json.products.forEach(function (row) {
                var pg = String((row && row.product_gid) || '').trim();
                if (!pg) return;
                slotsByGid[pg] = Array.isArray(row.slots) ? row.slots : [];
              });
            }
            // Failed batch still marks known waitlist — avoid stuck "fake bookable".
            stampGids(chunk, slotsByGid);
          });
      })
    ).then(function () {
      return list;
    });
  }

  /**
   * Calendar fetch for coral: single city product + venue + date window via events-batch.
   */
  function fetchVenueCalendar(booking, venue, dateFrom, dateTo, signal) {
    var productGid = String(
      (venue && (venue.sell_product_gid || venue.product_gid)) || ''
    ).trim();
    var venueRefId = String((venue && venue.venue_ref_id) || '').trim();
    if (!productGid) return Promise.reject(new Error('coral_hub_product_gid_missing'));
    if (!venueRefId) return Promise.reject(new Error('coral_hub_venue_ref_missing'));
    return fetchEventsBatch({
      productGid: productGid,
      venueRefId: venueRefId,
      dateFrom: dateFrom,
      dateTo: dateTo,
      signal: signal,
    }).then(function (body) {
      return slotsToEvents(body, venueRefId);
    });
  }

  /** Grid paints pages. Search keeps its own full product index and must not shrink it. */
  function assignSearchCatalog(booking, painted) {
    if (!booking) return;
    if (booking.__wbCoralSearchWarmDone || booking.__wbCoralSearchWarmInFlight) return;
    booking.__wbCoralSearchCatalog = (painted || []).slice();
  }

  /** Search index only: every collection product, no events, no grid paint. */
  function warmSearchCatalog(booking) {
    var handle = booking && booking.__wbCoralCollectionHandle;
    if (!handle) return Promise.resolve((booking && booking.__wbCoralSearchCatalog) || []);
    if (booking.__wbCoralSearchWarmDone && (booking.__wbCoralSearchCatalog || []).length) {
      return Promise.resolve(booking.__wbCoralSearchCatalog);
    }
    if (booking.__wbCoralSearchWarmInFlight) return booking.__wbCoralSearchWarmInFlight;
    booking.__wbCoralSearchWarmInFlight = fetchAllCollectionVenues(handle)
      .then(function (all) {
        var sorted = sortCoralVenues(dedupeVenues(all || []));
        booking.__wbCoralSearchCatalog = sorted;
        booking.__wbCoralSearchWarmDone = true;
        return sorted;
      })
      .catch(function () {
        return booking.__wbCoralSearchCatalog || [];
      })
      .then(function (rows) {
        booking.__wbCoralSearchWarmInFlight = null;
        return rows;
      });
    return booking.__wbCoralSearchWarmInFlight;
  }

  /** Presence for the current search rows only (180 days). Re-sorts search catalog by session. */
  function stampSearchPresence(venues) {
    return enrichVenuesAvailability(venues || [], { horizonDays: 180 }).then(function (list) {
      var roots = document.querySelectorAll('[data-wb-coral-hub="1"]');
      for (var i = 0; i < roots.length; i++) {
        var booking = roots[i];
        if (booking.__wbCoralSearchCatalog && booking.__wbCoralSearchCatalog.length) {
          booking.__wbCoralSearchCatalog = sortCoralVenues(booking.__wbCoralSearchCatalog);
        }
      }
      return list;
    });
  }

  function selectVenueFromSearch(booking, venue) {
    if (!booking || !venue) return false;
    var gid = String(venue.sell_product_gid || venue.product_gid || '').trim();
    var ref = String(venue.venue_ref_id || '').trim();
    var all = (booking.__wbCoralAllVenues || []).slice();
    var idx = -1;
    for (var i = 0; i < all.length; i++) {
      var g = String((all[i] && (all[i].sell_product_gid || all[i].product_gid)) || '').trim();
      var r = String((all[i] && all[i].venue_ref_id) || '').trim();
      if ((gid && g === gid) || (ref && r === ref)) {
        idx = i;
        break;
      }
    }
    if (idx < 0) {
      all.push(venue);
      all = sortCoralVenues(dedupeVenues(all));
      booking.__wbCoralAllVenues = all;
      assignSearchCatalog(booking, all);
      for (i = 0; i < all.length; i++) {
        g = String((all[i] && (all[i].sell_product_gid || all[i].product_gid)) || '').trim();
        r = String((all[i] && all[i].venue_ref_id) || '').trim();
        if ((gid && g === gid) || (ref && r === ref)) {
          idx = i;
          break;
        }
      }
    }
    var need = Math.max(Number(booking.__wbCoralVisibleCount) || 0, idx + 1, INITIAL_TARGET);
    booking.__wbCoralVisibleCount = Math.min(all.length, need);
    paintVisibleVenues(booking);
    global.setTimeout(function () {
      var want = String((all[idx] && all[idx].venue_ref_id) || ref || '').trim();
      if (!want) return;
      var card = booking.querySelector(
        '[data-venue-ref-id="' + (global.CSS && CSS.escape ? CSS.escape(want) : want) + '"]'
      );
      if (card && typeof card.click === 'function') card.click();
    }, 30);
    return true;
  }

  function boot(booking) {
    if (!booking || !isCoralHub(booking)) return Promise.resolve(false);
    booking.setAttribute('data-wb-coral-hub', '1');
    var col = typeCollectionHandle(booking);
    if (col) booking.setAttribute('data-wb-type-collection', col);
    return bootList(booking).then(function () {
      return true;
    });
  }

  function prefetchSellVariants(venue) {
    if (!venue || !venue.sell_product_handle) return Promise.resolve(venue);
    if (venue._sellVariantsLoaded) return Promise.resolve(venue);
    var handle = String(venue.sell_product_handle).trim();
    var url = rootPath().replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js';
    venue._sellVariantsLoaded = true;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('sell_product_js_' + res.status);
        return res.json();
      })
      .then(function (prod) {
        var byLabel = Object.create(null);
        var byId = Object.create(null);
        (prod.variants || []).forEach(function (v) {
          var id = String(v.id);
          var label = String(v.option1 || v.title || '')
            .trim()
            .toLowerCase();
          if (label) byLabel[label] = id;
          byId[id] = v;
        });
        venue._sellVariantByLabel = byLabel;
        venue._sellVariants = prod.variants || [];
        venue.sell_product_id = prod.id;
        return venue;
      })
      .catch(function () {
        venue._sellVariantsLoaded = false;
        return venue;
      });
  }

  function remapHubVariantId(venue, hubVariantId, hubVariantLabel) {
    if (!venue || !venue._sellVariantByLabel) return hubVariantId;
    var label = String(hubVariantLabel || '')
      .trim()
      .toLowerCase();
    if (label && venue._sellVariantByLabel[label]) return venue._sellVariantByLabel[label];
    return hubVariantId;
  }

  global.WorkshopBookingCoralHub = {
    isCoralHub: isCoralHub,
    typeCollectionHandle: typeCollectionHandle,
    boot: boot,
    loadMore: loadMore,
    fetchVenueCalendar: fetchVenueCalendar,
    windowBounds: windowBounds,
    prefetchSellVariants: prefetchSellVariants,
    remapHubVariantId: remapHubVariantId,
    warmSearchCatalog: warmSearchCatalog,
    stampSearchPresence: stampSearchPresence,
    selectVenueFromSearch: selectVenueFromSearch,
    INITIAL_TARGET: INITIAL_TARGET,
    PAGE_SIZE: PAGE_SIZE,
  };
})(typeof window !== 'undefined' ? window : this);
